
import LayoutContent from '../../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import SpecialsScreen from './../specials';


function Index({dishs, setShowListProduct, goHome}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

     const [showSpecials, setShowSpecials] = useState(false);

    
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowListProduct={setShowListProduct} setShowSpecials={setShowSpecials} goHome={goHome}>
                <div style={{ padding: '0 20px' }}>
<img
                         onContextMenu={(e) => e.preventDefault()}
                        src={require('../assets/top.png')}
                        style={{
                        objectFit: 'contain',
                            width: '100%',
                        pointerEvents: 'none',
                        height: 140,
                        marginTop: -10,
                        }}
                    />

                     <img
                         onContextMenu={(e) => e.preventDefault()}
                        src={require('../assets/beerb.png')}
                        style={{
                        objectFit: 'contain',
                            width: '100%',
                        pointerEvents: 'none',
                        height: 200,
                        marginTop: 10,
                        }}
                    />


                    <div>
                        <img
                             onContextMenu={(e) => e.preventDefault()}
                            src={require('./assets/beers2.png')}
                            style={{
                                width: '100%',
                                height: 400,
                                 pointerEvents: 'none',
                                objectFit: 'contain',
                                borderRadius: 20,
                                marginTop: 20,
                            }}
                        />
                    </div>
                
                </div>
                
                {showSpecials && <SpecialsScreen  setShowHappy={goHome} setShowListProduct={setShowSpecials} />}
            </LayoutContent>
        </div>
    );
}
export default Index;